import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {
  Box,
  Breadcrumbs,
  CardMedia,
  Divider,
  Drawer,
  FormControl,
  Hidden,
  InputLabel,
  Link,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { Location } from 'history';
import { ReactElement, useEffect, useState } from 'react';
import { CommonLayout } from '../../commonComponents';
import { Redirect, Route, Switch, useHistory, useRouteMatch, Router } from 'react-router-dom';
import { AnimatedBox, ReportLeftLayout, SectionLinkItem } from '../../InvestorReport/index';
// import ClientStatement from './client-statement';
// import TransactionStatement from './transaction-statement';
// import PortfolioSummary from './portfolio-summary';
// import CGStatement from './cg-statement';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { HoldingReport } from './holding-report';
import { PortfolioXirrReport } from './portfolio-xirr-report';
import { T1Report } from './t-1-report';
import { MFTransactionWiseHoldingReport } from './MF-Transactionwise-holding-report';
import { CapitalGainStatement } from './capital-gain-statement';
import { TransactionHistoryReport } from './transaction-history-report';
import { DetailedHoldingReport } from './DetailedHoldingReport';
import { CGStatIcon, PortfolioReportIcon, PortfolioXirrDisabledIcon, PortfolioXirrIcon, RMHoldingReportIcon, ReportsCGSDisabledIcon, ReportsClientStatementIcon, ReportsDetailedHoldingDisabledIcon, ReportsHoldingDisabledIcon, ReportsMFTxnIconDisabled, ReportsTxnHistoryDisabledIcon, ReportsTxnStatIcon, T1ReportDisabledIcon, T1ReportIcon } from '../../../assets/SvgIcons';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ClientStatement } from './ClientStatement';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import BreadCrum from '../../../lib/BreadCrum';
import { USER_ROLES } from '../../../utils/constant';


export interface ReportsRoutesObj {
  title: string;
  routerLink: string;
  isDisabled: boolean;
  icon: ReactElement;
  activeIcon: ReactElement;
  renderComponent: ReactElement
}

export default function DashboardReportRoute(): JSX.Element {
  const history = useHistory();
  const pathName = history.location.pathname;
  const { path } = useRouteMatch();
  const { role = '', } = useSelector((state: RootStateType) => state.auth);
  const currentPath = pathName.split('/');
  // const menuPath = leftMenuItem?.filter(item => item.routerLink === currentPath[2])[0]?.title;
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [isSideSectionDisabled, setSideSectionDisabled] = useState<boolean>(false)
  const [transitionClassName, setTransitionClassName] = useState('');
  //   const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };

  const handleSideSectionDisabled = (value: boolean) => {
    setSideSectionDisabled(value)
  }

  //Dont change the routerLink it will affect functionality
  const leftMenuItem = [
    {
      title: 'Client Statement',
      routerLink: `mf-client-statement`,
      isDisabled: true,
      icon: <ReportsMFTxnIconDisabled />,
      activeIcon: <ReportsClientStatementIcon />,
      renderComponent: <ClientStatement handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: true
    },
    {
      title: 'Holding Report',
      routerLink: `holding-report`,
      isDisabled: false,
      icon: <ReportsHoldingDisabledIcon />,
      activeIcon: <RMHoldingReportIcon />,
      renderComponent: <HoldingReport handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    {
      title: 'MF Transaction-wise Holding Report',
      routerLink: `mf-transaction-wise-holding-report`,
      isDisabled: false,
      icon: <ReportsMFTxnIconDisabled />,
      activeIcon: <ReportsClientStatementIcon />,
      renderComponent: <MFTransactionWiseHoldingReport handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    {
      title: 'Transaction History Report',
      routerLink: `transaction-history-report`,
      isDisabled: false,
      icon: <ReportsTxnHistoryDisabledIcon />,
      activeIcon: <ReportsTxnStatIcon />,
      renderComponent: <TransactionHistoryReport handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    {
      title: 'Capital Gain Statement',
      routerLink: `capital-gain-statement`,
      isDisabled: false,
      icon: <ReportsCGSDisabledIcon />,
      activeIcon: <CGStatIcon />,
      renderComponent: <CapitalGainStatement handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    {
      title: 'Portfolio XIRR Report',
      routerLink: `portfolio-xirr-report`,
      isDisabled: false,
      icon: <PortfolioXirrDisabledIcon />,
      activeIcon: <PortfolioXirrIcon />,
      renderComponent: <PortfolioXirrReport handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    {
      title: 'Holding (T-1) Report',
      routerLink: `t-1-report`,
      isDisabled: false,
      icon: <T1ReportDisabledIcon />,
      activeIcon: <T1ReportIcon />,
      renderComponent: <T1Report handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    // {
    //   title: 'Detailed Holding Report',
    //   routerLink: `DetailedHoldingReport`
    // },
  ];

  const links = [
    `${path}/mf-client-statement`,
    `${path}/mf-transaction-wise-holding-report`,
    `${path}/holding-report`,
    `${path}/capital-gain-statement`,
    `${path}/transaction-history-report`,
    `${path}/portfolio-xirr-report`,
    `${path}/t-1-report`,
    // `${path}/DetailedHoldingReport`
    // `${path}/portfolio-summary`,
    // `${path}/cg-statement`,
  ];


  const menuPath = leftMenuItem?.find(item => item.routerLink === currentPath[2])?.title
  const [currentMenuItem, setCurrentMenuItem] = useState<string>(menuPath ? menuPath : `${leftMenuItem.find(item => !item.isDisabled)?.title ?? leftMenuItem[0].title}`);

  const Menulinks = links.includes(pathName) ? links : [];
  const MenuItems = links.includes(pathName) ? leftMenuItem : [];


  const breadcrumbs = [

    <Link
      key="1"
      sx={{ cursor: 'pointer', textDecoration: 'none' }}
      onClick={() => history.push('/investors')}>
      Reports
    </Link>,
    <Typography key="2" color="text.primary">
      Download
    </Typography>,
  ];

  const rmRouterPath = [
    {
      name: 'Dashboard',
      path: '/dashboard',
    },
    {
      name: `Reports`,
      path: '/reports-download',
    },
  ]

  return (
    <CommonLayout>
      <>
        {/* <Box
          sx={{
            background: '#EEF9F4',
            borderRadius: '16px',
            px: 3,
            py: 1.5,
            mb: 2.5,
          }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{
              '& .MuiTypography-root': {
                fontSize: 20,
                lineHeight: '23px',
                fontWeight: 500,
                color: '#BBB5B5',
                '&.MuiTypography-body1': { color: '#22242C' },
              },
              '& .MuiBreadcrumbs-separator': {
                '& .MuiSvgIcon-root': { color: 'rgba(0,0,0,0.6)' },
                '&:last-of-type': {
                  background: 'red',
                  '& .MuiSvgIcon-root': { color: '#22242C' },
                },
              },
            }}>
            {breadcrumbs}
          </Breadcrumbs>
        </Box> */}

        <Box
          sx={{
            width: ['100%', '100%', '100%'],
            // ml: [0, 1, 1],
            pt: [0, 0, 0],
            pb: [0, 0, '60px'],
            boxSizing: 'border-box',
          }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
            sx={{ mb: "25px", display: ['none', 'flex', 'flex'] }}>
            {role === USER_ROLES.RM ? (
              <BreadCrum array={rmRouterPath} />
            ) :
              <Typography
                variant='h1'
                sx={{
                  color: 'text.primary',
                  lineHeight: '32.5px'
                }}>
                Reports
              </Typography>
            }
          </Stack>
          <Hidden smUp={true}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
              sx={{ display: ['flex', 'flex', 'flex'] }}>
              {role === USER_ROLES.RM ? (
                <BreadCrum array={rmRouterPath} />
              ) :
                <Typography
                  variant='h1'
                  sx={{
                    color: 'text.primary',
                    lineHeight: '32.5px'
                  }}>
                  Reports
                </Typography>
              }
            </Stack>
            {/* <Box
              sx={{
                borderRadius: '5px',
              }}>
              <Box sx={{ px: 3, pt: 2 }}>
                <FormControl fullWidth>
                  <InputLabel shrink id="investor-items"></InputLabel>
                  <Select
                    labelId="investor-items"
                    value={MenuItems[Menulinks?.indexOf(pathName)]?.routerLink}
                    onChange={(e) => {
                      // history.push(`${e.target.value}`, {
                      //   investorId: investorId,
                      //   investorName: investorName,
                      // });
                    }}
                    sx={{
                      color: 'primary.main',
                      fontWeight: 500,
                    }}
                    IconComponent={(props) => (
                      <ArrowDropDownIcon
                        {...props}
                        sx={{
                          paddingRight: '13px',
                          color: '#00D9DA !important',
                          cursor: 'pointer',
                        }}
                        fontSize="large"
                      />
                    )}>
                    {leftMenuItem.map((itemlist, ind) => (
                      <MenuItem
                        sx={{ borderBottom: '1px solid #ccc' }}
                        value={itemlist.routerLink}
                        key={ind}>
                        {itemlist.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box> */}
            <Box
              sx={(theme: Theme) => (
                {
                  my: 3,
                  p: '20px 18px',
                  background: theme.palette.common.white,
                  borderRadius: '20px',
                  cursor: isSideSectionDisabled ? 'not-allowed' : 'pointer',
                  opacity: isSideSectionDisabled ? 0.5 : 1
                }
              )}
              onClick={() => {
                if (!isSideSectionDisabled) {
                  setOpenDrawer(true)
                }
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                  {/* {currentMenuItem === leftMenuItem[0]?.title && <ReportsClientStatementIcon style={{ width: '12px', height: '12px' }} />}
                  {currentMenuItem === leftMenuItem[1]?.title && <ReportsClientStatementIcon />}
                  {currentMenuItem === leftMenuItem[2]?.title && <RMHoldingReportIcon />}
                  {currentMenuItem === leftMenuItem[3]?.title && <PortfolioReportIcon />}
                  {currentMenuItem === leftMenuItem[4]?.title && <ReportsTxnStatIcon />}
                  {currentMenuItem === leftMenuItem[5]?.title && <CGStatIcon />} */}
                  {leftMenuItem.find(item => item.title === currentMenuItem)?.activeIcon}
                  <Typography
                    variant='body_500'
                    sx={(theme: Theme) => ({
                      color: theme.palette.primary[500],
                    })}
                  >
                    {currentMenuItem}
                  </Typography>
                </Box>
                <ExpandMoreIcon />
              </Box>
            </Box>
          </Hidden>
          <Paper
            sx={{
              p: '25px',
              // backgroundColor: 'primary.light',
              boxShadow: '0,0,0,rgba(0,0,0,0.05)',
              borderRadius: [0, 0, '25px'],
              height: ['auto', 'auto', 'auto'],
            }}>
            <Stack direction="row" sx={{ width: '100%' }}>
              <Hidden only="xs">
                <ReportLeftLayout>
                  {
                    leftMenuItem.map((itemlist, ind) => {
                      if(itemlist?.isHidden) return;
                      return (
                        <SectionLinkItem
                          to={{
                            pathname: `${path}/${itemlist.routerLink}`,
                          }}
                          title={itemlist.title}
                          icon={itemlist.icon}
                          key={ind}
                          disabled={isSideSectionDisabled || itemlist.isDisabled}
                        />
                      )
                    })
                  }
                  {/* <SectionLinkItem
                    to={{
                      pathname: `${path}/mf-client-statement`,

                    }}
                    title={'Client Statement'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/client-statement.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsMFTxnIconDisabled />
                    }
                    disabled={isSideSectionDisabled || leftMenuItem[0]?.isDisabled}
                  /> */}
                  {/* {['RWM', 'RTL'].includes(ROLE_TYPE[`${subRole ?? ""}`.toUpperCase() as keyof typeof ROLE_TYPE]) && ( */}
                  <>
                    {/* <SectionLinkItem
                      to={{
                        pathname: `${path}/mf-transaction-wise-holding-report`,

                      }}
                      title={'MF Transaction-wise Holding Report'}
                      icon={
                        // <CardMedia
                        //   component="img"
                        //   src="/images/client-statement.svg"
                        //   sx={{ width: 'unset', mx: 'auto' }}
                        // />
                        <ReportsMFTxnIconDisabled />
                      }
                      disabled={isSideSectionDisabled || leftMenuItem[1]?.isDisabled}
                    />
                    <SectionLinkItem
                      to={{
                        pathname: `${path}/holding-report`,

                      }}
                      title={'Holding Report'}
                      icon={
                        // <CardMedia
                        //   component="img"
                        //   src="/images/cg-statement.svg"
                        //   sx={{ width: 'unset', mx: 'auto' }}
                        // />
                        <ReportsHoldingDisabledIcon />
                      }
                      disabled={isSideSectionDisabled || leftMenuItem[2]?.isDisabled}
                    />
                    <SectionLinkItem
                      to={{
                        pathname: `${path}/capital-gain-statement`,

                      }}
                      title={'Capital Gain Statement'}
                      icon={
                        // <CardMedia
                        //   component="img"
                        //   src="/images/portfolio-summary.svg"
                        //   sx={{ width: 'unset', mx: 'auto' }}
                        // />
                        <ReportsCGSDisabledIcon />
                      }
                      disabled={isSideSectionDisabled || leftMenuItem[3]?.isDisabled}
                    />
                    <SectionLinkItem
                      to={{
                        pathname: `${path}/transaction-history-report`,

                      }}
                      title={'Transaction History Report'}
                      icon={
                        // <CardMedia
                        //   component="img"
                        //   src="/images/transaction-statement.svg"
                        //   sx={{ width: 'unset', mx: 'auto' }}
                        // />
                        <ReportsTxnHistoryDisabledIcon />
                      }
                      disabled={isSideSectionDisabled || leftMenuItem[4]?.isDisabled}
                    /> */}
                    {/* <SectionLinkItem
                      to={{
                        pathname: `${path}/DetailedHoldingReport`,

                      }}
                      title={'Detailed Holding Report'}
                      icon={
                        // <CardMedia
                        //   component="img"
                        //   src="/images/client-statement.svg"
                        //   sx={{ width: 'unset', mx: 'auto' }}
                        // />
                        <ReportsDetailedHoldingDisabledIcon />
                      }
                      disabled={isSideSectionDisabled}
                    /> */}
                  </>
                  {/* )} */}
                  {/* <SectionLinkItem
                      to={{
                        pathname: `${path}/client-statement`,
                        state: {
                          investorId: investorId,
                          investorName: investorName,
                        },
                      }}
                      title={'Client Statement'}
                      icon={
                        <CardMedia
                          component="img"
                          src="/images/client-statement.svg"
                          sx={{ width: 'unset', mx: 'auto' }}
                        />
                      }
                    />
                    <SectionLinkItem
                      to={{
                        pathname: `${path}/transaction-statement`,
                        state: {
                          investorId: investorId,
                          investorName: investorName,
                        },
                      }}
                      title={'Transaction Statement'}
                      icon={
                        <CardMedia
                          component="img"
                          src="/images/transaction-statement.svg"
                          sx={{ width: 'unset', mx: 'auto' }}
                        />
                      }
                    />
                    <SectionLinkItem
                      to={{
                        pathname: `${path}/portfolio-summary`,
                        state: {
                          investorId: investorId,
                          investorName: investorName,
                        },
                      }}
                      title={'Portfolio Summary'}
                      icon={
                        <CardMedia
                          component="img"
                          src="/images/portfolio-summary.svg"
                          sx={{ width: 'unset', mx: 'auto' }}
                        />
                      }
                    />
                    <SectionLinkItem
                      to={{
                        pathname: `${path}/cg-statement`,
                        state: {
                          investorId: investorId,
                          investorName: investorName,
                        },
                      }}
                      title={'CG Statement'}
                      icon={
                        <CardMedia
                          component="img"
                          src="/images/cg-statement.svg"
                          sx={{ width: 'unset', mx: 'auto' }}
                        />
                      }
                    /> */}
                </ReportLeftLayout>
              </Hidden>
              {/* <Divider
                orientation="vertical"
                sx={{
                  borderWidth: '1px',
                  borderColor: 'text.dividerLight',
                  mr: 1,
                  ml: 2,
                  display: ['none', 'none', 'flex'],
                }}
                flexItem
              /> */}
              <AnimatedBox
                sx={{
                  minWidth: "200px",
                  flex: 2
                }}
                className={transitionClassName}
              >
                <Box sx={(theme: Theme) => (
                  {
                    // mt: { xs: -2 },
                    border: `1px solid ${theme.palette.text.secondary}26`,
                    padding: '35px',
                    borderRadius: '15px',
                  }
                )}>
                  <Router history={history}>
                    <Switch>
                      <Redirect
                        exact
                        from={path}
                        to={{
                          // pathname: `${path}/mf-client-statement`,
                          pathname: `${path}/${leftMenuItem.filter((item) => !item.isDisabled)?.[0]?.routerLink}`,
                          // state: { investorId, investorName },
                        }}
                      />
                      {
                        leftMenuItem.map((item, index) => (
                          <Route
                            key={index}
                            path={`${path}/${item.routerLink}`}
                            render={() => (
                              item.renderComponent
                            )}
                          />
                        ))
                      }
                      {/* <Route
                        path={`${path}/mf-client-statement`}
                        render={() => (
                          <ClientStatement
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/mf-transaction-wise-holding-report`}
                        render={() => (
                          <MFTransactionWiseHoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/holding-report`}
                        render={() => (
                          <HoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/capital-gain-statement`}
                        render={() => (
                          <CapitalGainStatement
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/transaction-history-report`}
                        render={() => (
                          <TransactionHistoryReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />

                        )}
                      /> */}
                      {/* <Route
                        path={`${path}/DetailedHoldingReport`}
                        render={() => (
                          <DetailedHoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      /> */}
                      {/* <Redirect
                          exact
                          from={path}
                          to={{
                            pathname: `${path}/client-statement`,
                            state: { investorId, investorName },
                          }}
                        />
                        <Route
                          path={`${path}/client-statement`}
                          render={(props) => (
                            <ClientStatement
                              {...props}
                              // investorId={investorId}
                              // investorName={investorName}
                              location={location}
                            />
                          )}
                        />
                        <Route
                          path={`${path}/transaction-statement`}
                          render={(props) => (
                            <TransactionStatement
                              {...props}
                              // investorId={investorId}
                              // investorName={investorName}
                              location={location}
                            />
                          )}
                        />
                        <Route
                          path={`${path}/portfolio-summary`}
                          render={(props) => (
                            <PortfolioSummary
                              {...props}
                              // investorId={investorId}
                              // investorName={investorName}
                              location={location}
                            />
                          )}
                        />
                        <Route
                          path={`${path}/cg-statement`}
                          render={(props) => (
                            <CGStatement
                              {...props}
                              // investorId={investorId}
                              // investorName={investorName}
                              location={location}
                            />
                          )}
                        /> */}
                    </Switch>
                  </Router>
                </Box>
              </AnimatedBox>
            </Stack>
          </Paper>
        </Box>


        {/* Drawer */}
        <Drawer anchor='bottom' open={openDrawer} onClose={() => setOpenDrawer(false)}
          sx={{
            borderRadius: '25px 25px 0px 0px',
            ".MuiPaper-elevation": {
              borderRadius: '25px 25px 0px 0px'
            }
          }}
        >
          {<DrawerList currentMenuItem={currentMenuItem} setCurrentMenuItem={setCurrentMenuItem} leftMenuItem={leftMenuItem} setOpenDrawer={setOpenDrawer} links={links} />}
        </Drawer>

      </>
    </CommonLayout>
  );
}

const DrawerList = ({ currentMenuItem, setCurrentMenuItem, leftMenuItem, setOpenDrawer, links }: { currentMenuItem: string, setCurrentMenuItem: React.Dispatch<React.SetStateAction<string>>, leftMenuItem: ReportsRoutesObj[], setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>, links: any }) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const theme = useTheme();
  const handleClick = (row: ReportsRoutesObj) => {
    setOpenDrawer(false)
    setCurrentMenuItem(row?.title)
    history.push(row?.routerLink)
  }
  return (
    <List sx={{ padding: '10px 20px' }}>
      {leftMenuItem?.map((row: any, index: number) => (
        <ListItemButton
          key={index}
          onClick={() => handleClick(row)}
          sx={{ display: 'flex', alignItems: 'center', columnGap: '15px', color: currentMenuItem === row?.title ? theme.palette.primary[500] : theme.palette.text.primary }}
          disabled={row?.isDisabled}
        >
          {/* {index === 0 && <ReportsMFTxnIconDisabled />}
          {index === 1 && <ReportsMFTxnIconDisabled />}
          {index === 2 && <ReportsHoldingDisabledIcon />}
          {index === 3 && <ReportsCGSDisabledIcon />}
          {index === 4 && <ReportsTxnHistoryDisabledIcon />}
          {index === 5 && <ReportsDetailedHoldingDisabledIcon />} */}
          {currentMenuItem === row?.title ? row?.activeIcon : row?.icon}
          <ListItemText>
            {row?.title}
          </ListItemText>
        </ListItemButton>

      ))}
    </List>


  )
}

